import classNames from "classnames";
import "./balances-dropdown.css";
import { ApiResponse } from "../../../../service/models";
import { formatCurrency } from "../../../../utils/formatCurrency";

const portalUrl = process.env.PORTAL_URL;
const sefazUrl = process.env.SEFAZ_URL;

type BalancesDropdownProps = {
  isOpen: boolean;
  onClose?: () => void;
  notaPiauiense: ApiResponse | null;
};

export function BalancesDropdown({
  isOpen,
  onClose,
  notaPiauiense,
}: BalancesDropdownProps) {
  if (!isOpen) return null;

  function handleAccessBalance() {
    window.location.replace(`${portalUrl}/app/app-nota-piauiense`);
    onClose?.();
  }

  function handleRedeemBalance() {
    const windowBlack = window.open(
      `${sefazUrl}/portalnota/jsp/login/login.jsf`,
      "_blank"
    );

    if (windowBlack) {
      windowBlack.focus();
    }
    onClose?.();
  }

  const balance = notaPiauiense?.data?.saldoNotaPovo?.saldoLiberado;

  return (
    <div className="balances-dropdown">
      <div className="balances-dropdown__content">
        {/* Seção de Saldo Disponível */}
        <div className="balances-dropdown__available-balance">
          <div className="balances-dropdown__balance-label">
            Saldo disponível
          </div>
          <div className="balances-dropdown__balance-amount">
            {formatCurrency(balance)}
          </div>
          <div className="balances-dropdown__balance-note">
            Valor mínimo para saque R$ 25,00
          </div>
        </div>

        {/* Separador */}
        <div className="balances-dropdown__separator"></div>

        {/* Botões de Ação */}
        <div
          className={classNames("balances-dropdown__actions", {
            "only-one-button": !balance || Number(balance) === 0,
          })}
        >
          <button
            className="balances-dropdown__access-button"
            onClick={handleAccessBalance}
          >
            <span>Acessar saldo</span>
            {!balance && (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>

          {Number(balance) > 0 && (
            <button
              className="balances-dropdown__redeem-button"
              onClick={handleRedeemBalance}
            >
              <div className="balances-dropdown__redeem-icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              Resgatar saldo
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
